module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_null@3x.58dcf2fc.png";